import type React from 'react';
import { toast } from '@/components/ui/use-toast.jsx';
import { ImageDestinationEnum } from '@sportspredict/shared';

export const handleLobbyFileUpload = async (
	event: React.ChangeEvent<HTMLInputElement>,
	setIsUploading: (value: boolean) => void,
	UploadFile: (file: File, destination: ImageDestinationEnum, tag: string) => Promise<unknown>,
	tag: string
) => {
	const file = event.target.files?.[0];
	if (!file) return;

	try {
		setIsUploading(true);
		await UploadFile(file, ImageDestinationEnum.Lobby, tag);
		toast({
			title: 'Success',
			description: 'Image uploaded successfully',
		});
	} catch (error) {
		toast({
			variant: 'destructive',
			title: 'Error',
			description: 'Failed to upload image. Please try again.',
		});
		console.error(error);
		throw new Error('Error uploading image');
	} finally {
		setIsUploading(false);
	}
};

export const handleLobbyFileChange = async (
	event: React.ChangeEvent<HTMLInputElement>,
	setIsUploading: (value: boolean) => void,
	UploadFile: (file: File, destination: ImageDestinationEnum, tag: string) => Promise<unknown>,
	tag: string
) => {
	const file = event.target.files?.[0];
	if (!file) return;

	try {
		setIsUploading(true);
		await UploadFile(file, ImageDestinationEnum.Lobby, tag);
	} catch (error) {
		console.error(error);
		throw new Error('Error uploading avatar');
	} finally {
		setIsUploading(false);
	}
};
